var map = {
	"./bell-big.svg": 3785,
	"./calendar-alternative.svg": 7823,
	"./close-modal.svg": 277,
	"./flags/cs.svg": 897,
	"./flags/cs_big.svg": 5214,
	"./flags/de.svg": 6830,
	"./flags/de_big.svg": 8797,
	"./flags/en.svg": 5350,
	"./flags/it.svg": 2592,
	"./flags/sk.svg": 4025,
	"./flags/sk_big.svg": 7030,
	"./flags/usa_vi_big.svg": 1883,
	"./google-document.svg": 9308,
	"./graph-right.svg": 7560,
	"./graph-up.svg": 1173,
	"./icon-alert.svg": 6757,
	"./icon-check-circle-big.svg": 4873,
	"./icon-graduate-badge.svg": 3192,
	"./icon-no-data.svg": 1397,
	"./icon-no-meals.svg": 9927,
	"./icon-no-patients.svg": 2875,
	"./icon-times-circle-big.svg": 243,
	"./input-icon-check.svg": 9406,
	"./input-icon-times.svg": 2208,
	"./input-radio-check.svg": 8560,
	"./input-radio-times.svg": 1586,
	"./institution/doctor.svg": 6519,
	"./matrix/call.svg": 2835,
	"./matrix/compliance.svg": 5878,
	"./matrix/education.svg": 319,
	"./matrix/goals.svg": 8269,
	"./matrix/login.svg": 6574,
	"./matrix/meals.svg": 6569,
	"./matrix/mood.svg": 618,
	"./matrix/prescription.svg": 711,
	"./matrix/steps.svg": 9396,
	"./matrix/waist.svg": 4673,
	"./matrix/weight.svg": 6240,
	"./notion-document.svg": 3814,
	"./search-icon-app.svg": 4405,
	"./search.svg": 2308,
	"./show-pw.svg": 7594,
	"./tasks/1.svg": 531,
	"./tasks/2.svg": 5392,
	"./tasks/3.svg": 7633,
	"./tasks/4.svg": 8702,
	"./tasks/5.svg": 1279,
	"./tasks/6.svg": 2252,
	"./tasks/consultation_cancelled.svg": 5953,
	"./tasks/consultation_not_interested.svg": 3723,
	"./tasks/login.svg": 5397,
	"./tasks/moved_to_graduate_phase.svg": 2351,
	"./tasks/moved_to_sustain_phase.svg": 9235,
	"./tasks/new_patient_active.svg": 2587,
	"./tasks/new_patient_freemium.svg": 8463,
	"./tasks/prescription.svg": 9286,
	"./tooltips/big-info-hover.svg": 2564,
	"./tooltips/big-info.svg": 1065,
	"./tooltips/small-info-hover.svg": 2217,
	"./tooltips/small-info.svg": 9892,
	"./trash-red.svg": 6449,
	"./turn-on.svg": 4564,
	"./user_default.svg": 5812,
	"./vitadio-logo.svg": 5305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5312;